import React from 'react';

import Lozenge, { type LozengeProps } from '@atlaskit/lozenge';

const stateLozengePropsMap: Record<string, LozengeProps> = {
	ACTIVE: {
		appearance: 'success',
	},
	ARCHIVED: {
		appearance: 'default',
	},
	PENDING: {
		appearance: 'default',
	},
};

/**
 * @param state - The status of the compass component (e.g., 'PENDING', 'ACTIVE', 'ARCHIVED').
 */
export type SearchResultCompassStatusLozengeProps = {
	state?: string | null;
};

export const SearchResultCompassStatusLozenge = ({
	state,
}: SearchResultCompassStatusLozengeProps): React.JSX.Element | null => {
	if (!state) {
		return null;
	}

	const lozengeProps: LozengeProps = {
		appearance: 'default',
		isBold: true,
		...(state ? stateLozengePropsMap?.[state] : {}),
	};

	return <Lozenge {...lozengeProps}>{state}</Lozenge>;
};
